import { Component, ViewEncapsulation } from '@angular/core';
import { EncounterService } from '../../../services/encounter.service';
import { Store } from '@ngxs/store';
import { EncounterState } from '../../../state/encounters/encounter-state';
import { TabViewChangeEvent, TabViewModule } from 'primeng/tabview';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Encounters } from '../../../state/encounters/encounter-actions';
import { TealCompEncounter } from '../../../models/encounter';
import { ButtonModule } from 'primeng/button';
import { EncounterEditorComponent } from '../../encounter/encounter-editor/encounter-editor.component';
import { UserInterfaceState } from '../../../state/ui/ui-state';
import { UserInterface } from '../../../state/ui/ui-actions';
import { ClaimSidecarComponent } from '../claim-sidecar/claim-sidecar.component';

@Component({
  selector: 'app-workbench',
  standalone: true,
  imports: [TabViewModule,NgIf,NgFor,AsyncPipe,ButtonModule,EncounterEditorComponent, ClaimSidecarComponent, NgClass],
  templateUrl: './workbench.component.html',
  styleUrl: './workbench.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class WorkbenchComponent 
{
  constructor
  (
    private _encounter:EncounterService,
    private _store:Store
  )
  {

  }



  closeEncounter(encounter: TealCompEncounter)
  {
    this._store.dispatch(new Encounters.WorkbenchEncounterClosed({encounter:encounter}))
  }

  encounterSelected(event: TabViewChangeEvent)
  {
    this._store.dispatch(new Encounters.EncounterSelected({index:event.index}))
  }

  toggleClaimTray(event: MouseEvent)
  {
    this._store.dispatch(new UserInterface.ToggleClaimTray());
  }

  //This is the list of openend encounters
  openEncounters$ = this._store.select(EncounterState.openEncounters);
  activeEncounter$ = this._store.select(EncounterState.activeEncounter);
  activeIndex$ = this._store.select(EncounterState.activeEncounterIndex);
  claimTrayOpen$ = this._store.select(UserInterfaceState.claimTrayOpen);

}
